import {  observer } from 'mobx-react';
import React from 'react';
import ModalConfirmService from '../assistente-minutas/services/ModalConfirmService';
import ConfirmStore from '../store/ConfirmStore';
import Modal from './Modal';

interface IPropsModalConfirm {
}


class ModalConfirm extends React.Component {

    render() {
        return (
            <div>
                {ConfirmStore.acaoUnica ?
                    <Modal
                        aberto={ConfirmStore.modalAberto}
                        fecharModal={ModalConfirmService.fecharModal}
                        titulo={ConfirmStore.titulo}
                        funcaoAcaoPrimaria={ModalConfirmService.acaoDeConfirmar}
                        labelAcaoPrimaria='Fechar'
                        apenasAcaoPrimaria={true}
                    >
                        <div dangerouslySetInnerHTML={{ __html: ConfirmStore.corpo }}>
                        </div>
                    </Modal>
                    :
                    <Modal
                        aberto={ConfirmStore.modalAberto}
                        fecharModal={ModalConfirmService.fecharModal}
                        titulo={ConfirmStore.titulo}
                        funcaoAcaoSecundaria={ModalConfirmService.fecharModal}
                        labelAcaoSecundaria='Cancelar'
                        funcaoAcaoPrimaria={ModalConfirmService.acaoDeConfirmar}
                        labelAcaoPrimaria={'Confirmar'}
                    >
                        <div dangerouslySetInnerHTML={{ __html: ConfirmStore.corpo }}>
                        </div>
                    </Modal>
                }
            </div>
        );
    }
}

export default observer(ModalConfirm);
